import type { EasykitOverlayTask } from '@/api/easykit';
import { useEasykitPlanningStore } from '@/stores/easykitPlanning';

interface EasykitOverlayCardProps {
  task: EasykitOverlayTask;
}

export function EasykitOverlayCard({ task }: EasykitOverlayCardProps) {
  const selectOverlay = useEasykitPlanningStore((s) => s.selectOverlay);
  const selectedOverlayId = useEasykitPlanningStore((s) => s.selectedOverlayId);
  const isSelected = selectedOverlayId === task.id;
  const project = task.projectName ?? task.soName ?? null;
  const headline = project ?? task.name;
  const subline = project ? task.name : null;

  return (
    <button
      type="button"
      onClick={() => selectOverlay(task.id)}
      aria-pressed={isSelected}
      className={`block w-full text-left bg-slate-100 border border-dashed text-slate-600 text-xs px-2 py-1 rounded my-1 relative transition-colors hover:bg-slate-200 ${
        isSelected ? 'border-slate-600 ring-2 ring-slate-400/40' : 'border-slate-400'
      }`}
    >
      <span className="absolute top-0.5 right-0.5 text-[9px] font-bold bg-slate-300 text-slate-700 px-1 rounded">
        PL
      </span>
      <p className="truncate pr-6 font-medium">{headline}</p>
      {subline && <p className="truncate text-[11px] text-slate-500">{subline}</p>}
    </button>
  );
}
